import React from "react";
import { Box, Typography, Paper, Tooltip, Container } from "@mui/material";
import { ReactComponent as PythonIcon } from './icons/python.svg';
import { ReactComponent as JavaIcon } from './icons/java.svg';
import { ReactComponent as RIcon } from './icons/r.svg';
import { ReactComponent as JavascriptIconSvg } from './icons/javascript.svg';
import { ReactComponent as TerraformIcon } from './icons/terraform.svg';
import { ReactComponent as FlaskIcon } from './icons/flask.svg';
import { ReactComponent as JenkinsIcon } from './icons/jenkins.svg';
import { ReactComponent as AnsibleIcon } from './icons/ansible.svg';
import { ReactComponent as SonarQubeIcon } from './icons/sonarqube.svg';
import { ReactComponent as AwsIcon } from './icons/aws.svg';
import { ReactComponent as CSharpIcon } from './icons/icons8-c-sharp-logo-50.svg';
import { ReactComponent as AzureIcon } from './icons/azure.svg';
import { ReactComponent as DockerIcon } from './icons/docker.svg';
import { ReactComponent as KubernetesIcon } from './icons/kubernetes.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function SkillsSection() {
  const skills = [
    { name: 'Python', icon: <PythonIcon style={{ width: 40, height: 40 }} />, url: 'https://docs.python.org/3/' },
    { name: 'Java', icon: <JavaIcon style={{ width: 40, height: 40 }} />, url: 'https://docs.oracle.com/en/java/' },
    { name: 'C#', icon: <CSharpIcon style={{ width: 40, height: 40 }} />, url: 'https://docs.microsoft.com/en-us/dotnet/csharp/' },
    { name: 'R', icon: <RIcon style={{ width: 40, height: 40 }} />, url: 'https://www.r-project.org/other-docs.html' },
    { name: 'JavaScript', icon: <JavascriptIconSvg style={{ width: 40, height: 40 }} />, url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript' },
    { name: 'AWS', icon: <AwsIcon style={{ width: 40, height: 40 }} />, url: 'https://docs.aws.amazon.com/' },
    { name: 'Azure', icon: <AzureIcon style={{ width: 40, height: 40 }} />, url: 'https://docs.microsoft.com/en-us/azure/' },
    { name: 'Terraform', icon: <TerraformIcon style={{ width: 40, height: 40 }} />, url: 'https://www.terraform.io/docs' },
    { name: 'Docker', icon: <DockerIcon style={{ width: 40, height: 40 }} />, url: 'https://docs.docker.com/' },
    { name: 'Kubernetes', icon: <KubernetesIcon style={{ width: 40, height: 40 }} />, url: 'https://kubernetes.io/docs/home/' },
    { name: 'Flask', icon: <FlaskIcon style={{ width: 40, height: 40 }} />, url: 'https://flask.palletsprojects.com/' },
    { name: 'Jenkins', icon: <JenkinsIcon style={{ width: 40, height: 40 }} />, url: 'https://www.jenkins.io/doc/' },
    { name: 'Ansible', icon: <AnsibleIcon style={{ width: 40, height: 40 }} />, url: 'https://docs.ansible.com/' },
    { name: 'SonarQube', icon: <SonarQubeIcon style={{ width: 40, height: 40 }} />, url: 'https://docs.sonarqube.org/latest/' },
  ];

  return (
    <Box id="skills" sx={{
      py: 12,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      background: 'var(--white)'
    }}>
      <Container maxWidth="lg" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h3" fontWeight={700} sx={{
          color: 'var(--rosewood)',
          mb: 2,
          textAlign: 'center',
          letterSpacing: '-0.5px'
        }}>
          Skills
        </Typography>
        <Typography variant="h6" sx={{
          color: 'var(--chinese-violet)',
          mb: 8,
          textAlign: 'center',
          fontWeight: 400,
          maxWidth: '700px'
        }}>
          Tools I like and know how to use
        </Typography>

        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: { xs: 2, sm: 3 },
          maxWidth: '1200px'
        }}>
          {skills.map((skill) => (
            <Tooltip title={skill.name} arrow placement="top" key={skill.name}>
              <a href={skill.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <Paper elevation={0} sx={{
                  p: { xs: 2, sm: 3 },
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 2,
                  width: { xs: 'calc(50% - 16px)', sm: 'calc(33.33% - 24px)', md: '150px' },
                  minWidth: '120px',
                  aspectRatio: '1/1',
                  background: 'var(--white)',
                  border: '1px solid rgba(0,0,0,0.1)',
                  transition: 'border-color 0.15s ease',
                  cursor: 'pointer',
                  '&:hover': {
                    borderColor: 'var(--pacific-cyan)'
                  }
                }}>
                  <Box sx={{
                    mb: 2,
                    filter: 'grayscale(100%)',
                    transition: 'all 0.3s ease',
                    '.MuiPaper-root:hover &': { filter: 'grayscale(0%)' }
                  }}>
                    {skill.icon}
                  </Box>
                  <Typography variant="body1" fontWeight={600} sx={{ color: 'var(--black)', textAlign: 'center' }}>
                    {skill.name}
                  </Typography>
                </Paper>
              </a>
            </Tooltip>
          ))}
        </Box>

        {/* Scroll Down Arrow */}
        <Box sx={{ mt: 8, cursor: 'pointer' }} 
          onClick={() => {
            const nextSection = document.getElementById('contact');
            if (nextSection) {
              nextSection.scrollIntoView({ behavior: 'smooth' });
            }
          }}
        >
          <KeyboardArrowDownIcon sx={{ fontSize: 40, color: 'var(--chinese-violet)', opacity: 0.6 }} />
        </Box>
      </Container>
    </Box>
  );
}
